// In production the web (Pages) and the API (Worker) are different
// origins, so the non-tRPC routes — photo upload and image serving —
// must target the Worker explicitly. Locally VITE_API_URL is unset and
// Vite proxies these same paths, so an empty base means "same origin".
export const API_BASE = import.meta.env.VITE_API_URL ?? "";

/**
 * Absolute URL for a Worker route (`/upload`, `/media/...`). Leaves
 * already-absolute URLs untouched — e.g. a `blob:` capture preview or a
 * full `https:` URL — so it's safe to wrap any image source.
 */
export function apiUrl(path: string): string {
  if (/^(https?:|blob:|data:)/.test(path)) return path;
  return `${API_BASE}${path}`;
}
